// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { getObjectKeys, NullPartial, pickKeys, subsetTypeHasKey, ValueOf } from "@hex-insights/core";
import {
	EmailAddressCreateInput,
	EmailAddressDetailQuery,
	EmailAddressInPersonCreateInput,
	EmailAddressUpdateInput,
} from "../../../Utilities";
import * as EmailAddressFormValues from "./form-values";

/**
 * Converts the given `formValues` for the create form to a GraphQL create input for the EmailAddress model.
 *
 * @param formValues The form values to convert.
 */
export function toGQLCreateInput<K extends keyof EmailAddressFormValues.Create = keyof EmailAddressFormValues.Create>(
	formValues: EmailAddressFormValues.CreateSubset<K>,
): EmailAddressCreateInput {
	const input: NullPartial<EmailAddressCreateInput> = { ...formValues };
	return input as EmailAddressCreateInput;
}

/**
 * Converts the given `formValues` for the create form nested in the Person to a GraphQL nested create input for the EmailAddress model.
 *
 * @param formValues The form values to convert.
 */
export function toGQLCreateInPersonInput<
	K extends keyof EmailAddressFormValues.CreateInPerson = keyof EmailAddressFormValues.CreateInPerson,
>(formValues: EmailAddressFormValues.CreateInPersonSubset<K>): EmailAddressInPersonCreateInput {
	const input: NullPartial<EmailAddressInPersonCreateInput> = { ...formValues };
	return input as EmailAddressInPersonCreateInput;
}

/**
 * Converts the given `formValues` for the detail form to a GraphQL update input for the EmailAddress model.
 *
 * @param formValues The form values to convert. Generally only the changed form values.
 * @param initialFormValues The initial values of the form.
 */
export function toGQLUpdateInput<K extends keyof EmailAddressFormValues.Detail = keyof EmailAddressFormValues.Detail>(
	formValues: Partial<EmailAddressFormValues.DetailSubset<K>>,
	_initialFormValues?: EmailAddressFormValues.DetailSubset<K>,
): EmailAddressUpdateInput {
	const input: EmailAddressUpdateInput = { ...formValues };

	if (subsetTypeHasKey(formValues, "personID") && formValues.personID === null) {
		input.personID = null;
		input.clearPerson = true;
	}

	return input;
}

export type EmailAddressFormKeyMap = {
	name: "name";
	emailAddress: "emailAddress";
	isPrimary: "isPrimary";
	personID: "person";
};

export type ToFormValuesArgs<K extends keyof EmailAddressFormValues.Detail = keyof EmailAddressFormValues.Detail> = {
	emailAddress: Pick<EmailAddressDetailQuery["emailAddress"], ValueOf<Pick<EmailAddressFormKeyMap, K>>>;
	fields?: { [Key in K]: true };
};

/**
 * Converts a EmailAddress instance to its corresponding detail form values.
 *
 * @param emailAddress The instance to convert.
 * @param fields The subset of fields to include.
 */
export function toFormValues<K extends keyof EmailAddressFormValues.Detail = keyof EmailAddressFormValues.Detail>({
	emailAddress,
	fields,
}: ToFormValuesArgs<K>): EmailAddressFormValues.DetailSubset<K> {
	const formValues = {
		name: subsetTypeHasKey(emailAddress, "name") ? emailAddress.name : "",
		emailAddress: subsetTypeHasKey(emailAddress, "emailAddress") ? emailAddress.emailAddress : "",
		isPrimary: subsetTypeHasKey(emailAddress, "isPrimary") ? emailAddress.isPrimary : false,
		personID: subsetTypeHasKey(emailAddress, "person") ? emailAddress.person?.id ?? null : null,
	};
	return fields ? pickKeys(formValues, getObjectKeys(fields)) : formValues;
}
